export default __webpack_public_path__ + "static/media/carousel3.6ea289a0.png";